import api from '@/core/apiclient'
import {actionTypes, mimeTypes, mutationTypes} from '@/core/constants'
import {DownloadUtils} from '@/core/utils'
import produto from '@/core/constants/produto'

const downloadUtils = new DownloadUtils()

export default {

    async [actionTypes.VALIDAR_DOCUMENTO_VIRTUALIZADO](context, codigo){
        const {data} = await api.validarDocumentoApi.validarDocumento(codigo)
        return {
            valido: data.ehDocumentoValido,
            idVirtualizado: data.documentoVirtualizadoId,
            arquivoSrc: data.arquivoSrc,
            dataHoraValidacao: data.dataHoraPesquisa,
            nome: data.nomeDocumento
        }
    },

    async [actionTypes.BAIXAR_DOCUMENTOS_VIRTUALIZADOS](context, {id, nome}){
        const {data} = await api.validarDocumentoApi.baixarDocumentos(id)
        let blob = new Blob([data], {
            type: 'application/zip'
        })
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = nome ? nome : 'Documentos'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    },

    async [actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA](context, compraDiretaId){
        const {data} = await api.compraDireta.baixarAtaPublica(compraDiretaId)
        const nomeArquivo = 'Relatorio_da_Ata.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf)
    },

    async [actionTypes.BUSCAR_COMPRAS_DIRETAS_PUBLICAS](context, {filtros, paginacao}){
        const {data} = await api.compraDireta.buscarComprasDiretasPublicas(filtros, paginacao)
        return data
    },

    async [actionTypes.BUSCAR_DADOS_GERAIS_PUBLICO]({commit}, compraDiretaId){
        const {data} = await api.compraDireta.buscarComprasDiretasPublicasPorId(compraDiretaId)
        commit(mutationTypes.SET_COMPRA_DIRETA, data)
    },

    async [actionTypes.DOWNLOAD_ANEXO](context, arquivoInfo){
        const {data} = await api.arquivoApi.download(arquivoInfo.uri)
        downloadUtils.baixarBlob(data, arquivoInfo.nome, mimeTypes.pdf)
    },

    async [actionTypes.BAIXAR_DOCUMENTO_VIRTUALIZADO](context, {idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital}){
        const {data} = await api.arquivoApi.baixarDocumentoVirtualizado(idVirtualizado, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital)
        downloadUtils.baixarBlob(data, `${nomeArquivo}-${compraDiretaId}.pdf`, mimeTypes.pdf)
    },

    async [actionTypes.BUSCAR_ITENS_E_LOTES]({ commit }, compraDiretaId) {
        const { data } = await api.compraDireta.buscarItensELotes(compraDiretaId)
        commit(mutationTypes.SET_ITENS_E_LOTES, data)
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_SOLICITADOS]({ commit }, compraDiretaId) {
        const { data } = await api.compraDireta.buscarDocumentosSolicitados(compraDiretaId)
        commit(mutationTypes.SET_DOCUMENTOS_SOLICITADOS, data.items)
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA]({ commit }) {
        const { data } = await api.compraDireta.buscarPorNivelProposta()
        commit(mutationTypes.SET_DOCUMENTOS_PROPOSTA, data.documentos)
    },

    async [actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA]({ commit }, compraDiretaId) {
        const { data } = await api.compraDireta.buscarDaCompraDireta(compraDiretaId)
        commit(mutationTypes.SET_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA, data.items)
    },

    async [actionTypes.BUSCAR_RESULTADO_DE_TODOS_LOTES_E_ITENS](context , compraDiretaId) {
        const { data } = await api.compraDireta.buscarResultadoLotesItens(compraDiretaId)
        return data
    },

    async [actionTypes.BUSCAR_RESUMO_DA_COMPRA_DIRETA_NA_PROPOSTA](context, { compraDiretaId, propostaId }) {
        const { data } = await api.compraDireta.buscarResumoProposta(compraDiretaId, propostaId)
        return data
    },

    async [actionTypes.BUSCAR_USUARIO_LOGADO]({ commit, state }) {
        const produtoId = state.loki.product.id
        const { data } = await api.usuario.buscarLogado(produtoId)
        commit(mutationTypes.SET_USUARIO_LOGADO, data)
    },

    async [actionTypes.BUSCAR_PRODUTO_POR_NOME]({ commit }) {
        const { data } = await api.produto.buscarPorNome(produto.NOME)
        commit(mutationTypes.SET_PRODUTO, data)
    },

}
